import { getWidgetPlacement } from '@wix/wix-chatbot-common/bi';

import { renderModel } from '../util/renderModel';

const getParentUrlReferral = (url: string | null): string | null => {
  return url ? new URL(url)?.searchParams.get('referral') : null;
};

const url = new URL(window.location.href);

export const parentUrl = url.searchParams.get('loadPageUrl');
export const referralUrl = url.searchParams.get('referral_url') || document.referrer;

export const locale = renderModel.getLocale();
const isFullWidth = renderModel.isFullWidth();
export const referral = isFullWidth ? getParentUrlReferral(parentUrl) : url.searchParams.get('referral');

export const placement = getWidgetPlacement(isFullWidth, renderModel.isInvokedFromHeader());
